export default {
  conversation_dnd_message: '{name}处于DND状态',
  conversation_dnd_message_with_time:
    '{time, time, short}前{name}一直处于DND状态',
  conversation_dnd_message_tooltip_content: '{name}不会收到通知',
};
